import React from "react";
import { withTranslation } from 'react-i18next';
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { toast } from 'react-toastify';

import { apiBlob } from "../../../../api/api";

class MaterialsObjectDragDrop extends React.Component {

    state = { items: [] };
    constructor(props) {
        super(props);

        this.onDragEnd = this.onDragEnd.bind(this);
    }

    static getDerivedStateFromProps(props, state) {
        if (props.items) {
            state.items = props.items;
        }
        return state;
    }

    onDragEnd(result) {
        // dropped outside the list
        if (!result.destination) {
            return;
        }

        const items = this.reorder(
            this.state.items,
            result.source.index,
            result.destination.index
        );

        this.setState({
            items
        });

        this.props.setSort(items);
    }

    reorder = (list, startIndex, endIndex) => {
        const result = Array.from(list);
        const [removed] = result.splice(startIndex, 1);
        result.splice(endIndex, 0, removed);

        return result;
    };

    getListStyle = isDraggingOver => ({
        // background: !isDraggingOver ? "rgb(246 250 249)" : "#fff",
        padding: 10,
        border: ' 5px dashed rgb(255, 255, 255)'
    });

    getItemStyle = (isDragging, draggableStyle) => ({
        // styles we need to apply on draggables
        ...draggableStyle,
        // some basic styles to make the items look a bit nicer
        userSelect: "none",
        padding: '2px 5px',
        margin: `0 0 ${8}px 0`,
        position: 'static !important',
        // change background colour if dragging
        borderBottom: isDragging ? "2px dashed lightgreen" : "2px solid rgb(14, 44, 83)",
    });

    View = item => {
        if (item.type === "Exams" || item.type === "Quizzes") {
            window.openExamView(item.id);
        } else if (item.type === "SelfDevelopment") {
            window.openSelfDevelopmentView(item.id);
        } else if (item.type === "Games" || item.type === "Fun") {
            window.openGameView(item.id);
        } else {
            window.openLessonView(item.id);
        }
    }

    Download = item => {
        const { t } = this.props;

        let _toastId = toast(t('Processing'), {
            position: "bottom-left",
            autoClose: false
        });
        toast.update(_toastId, {
            render: () => <div> <i className="fa-spin fas fa-spinner"></i> {t('Processing')} </div>,
            autoClose: false,
            closeOnClick: false,
        });

        apiBlob.post(`/EducationalFileById/${item.id}`).then(response => {
            if (response) {
                var a = document.createElement("a");
                document.body.appendChild(a);
                a.style.display = "none";
                const blob = new Blob([response.data]),
                    url = window.URL.createObjectURL(blob);
                a.href = url;
                a.download = item.title + '.' + item.extension;
                a.click();
                window.URL.revokeObjectURL(url);
            }
            toast.dismiss(_toastId);
        }).catch(error => {
            toast.dismiss(_toastId);
        });
    }

    render() {
        const { t } = this.props;
        return (
            <>
                <DragDropContext onDragEnd={this.onDragEnd} className="position-relative align-self-cente  ">
                    <Droppable droppableId="droppable" >
                        {(provided, snapshot) => (
                            <div
                                {...provided.droppableProps}
                                ref={provided.innerRef}
                                className="sortedItem w-100 p-0 m-0"
                                style={this.getListStyle(snapshot.isDraggingOver)}
                            >
                                {this.state.items.map((item, index) => (
                                    <Draggable key={index} draggableId={`${index}`} index={index}>
                                        {(provided, snapshot) => (
                                            <div
                                                ref={provided.innerRef}
                                                {...provided.draggableProps}
                                                {...provided.dragHandleProps}
                                                style={this.getItemStyle(
                                                    snapshot.isDragging,
                                                    provided.draggableProps.style
                                                )}
                                                className="subItem"
                                            >
                                                <div className="d-flex justify-content-between">
                                                    <span className="m-1">
                                                        {item.title}
                                                    </span>
                                                    <span className="m-1 mx-2">
                                                        {
                                                            item.type === "File" ?
                                                                <div className="btn btn-sm btn-info mx-1" title={t('Pages.Lessons.Questions.forms.tools.download')} onClick={() => this.Download(item)}>
                                                                    <i className="fal fa-download"></i>
                                                                </div>
                                                                :
                                                                <div className="btn btn-sm btn-info mx-1" title={t('Pages.Lessons.Questions.forms.tools.view')} onClick={() => this.View(item)}>
                                                                    <i className="fal fa-eye"></i>
                                                                </div>
                                                        }

                                                        <div className="btn btn-sm btn-danger mx-1" title={t('Pages.Lessons.Questions.forms.tools.delete')} onClick={() => this.props.DeleteItem(item.id)}>
                                                            <i className="fal fa-trash"></i>
                                                        </div>
                                                    </span>
                                                </div>
                                            </div>
                                        )}
                                    </Draggable>
                                ))}
                                {provided.placeholder}
                            </div>
                        )}
                    </Droppable>
                </DragDropContext>
            </>
        );
    }
}
export default withTranslation('common')(MaterialsObjectDragDrop);